import { Database, Grid } from "react-feather";
import { FREE, PricingPlan, Selected, Storage, TrialVersion } from "../../../../constants";
import { dynamicImage } from "../../../../utils";
import { Button, Progress } from "reactstrap";
import { Image } from "../../../../coreComponents/Image";

const BottomList = () => {
  return (
    <>
      <ul>
        <li>
          <Button outline color="primary"><Database />{Storage}</Button>
        </li>
        <li>
          <div className="m-t-15">
            <Progress color="primary" style={{ height: "8px" }} value={25} className="mb-3" />
            <h6>{"25 GB of 100 GB used"}</h6>
          </div>
        </li>
      </ul>
      <hr />
      <ul>
        <li>
          <Button outline color="primary"><Grid />{PricingPlan}</Button>
        </li>
        <li>
          <div className="pricing-plan">
            <h6>{TrialVersion} </h6>
            <h5>{FREE}</h5>
            <p>{"100GB Space"}</p>
            <Button className="w-auto" size="xs" color="primary" outline>{Selected}</Button>
            <Image className="bg-img" src={dynamicImage(`dashboard/folder.png`)} alt="dashboard" />
          </div>
        </li>
      </ul>
    </>
  );
};

export default BottomList;